import type { SanityPageBuilderRgbSection, SanityPageBuilderSection } from "@ouster/shared";
import { RgbBlockView, rgbBgVideoProps, type RgbBlockViewSlide } from "~/features/blocks/inventory/rgb";
import { toCraftLinkArray } from "~/features/sanity/link";
import { toCraftMedia } from "~/features/sanity/media";
import { SanityRichText } from "~/features/sanity/rich-text";
import { Media } from "~/features/ui/media";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderRgbSection;
  };
};
function renderRgbMedia(media: ReturnType<typeof toCraftMedia>) {
  if (!media) {
    return undefined;
  }
  return <Media {...media} imageProps={{
    fit: "cover",
    rounded: false
  }} inlineVideoProps={{
    fit: "cover",
    rounded: false
  }} externalVideoProps={rgbBgVideoProps} />;
}
export function SanityRgbSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const text = sectionContent.text?.length ? <SanityRichText value={sectionContent.text} /> : undefined;
  const slides = sectionContent.slides?.map<RgbBlockViewSlide>(slide => ({
    headline: slide.headline,
    link: toCraftLinkArray(slide.link),
    media: renderRgbMedia(toCraftMedia(slide.media)),
    text: slide.text?.length ? <SanityRichText value={slide.text} /> : undefined
  })) ?? [];
  return <RgbBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} getSlideKey={(_slide, index) => sectionContent.slides?.[index]?._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} media={renderRgbMedia(toCraftMedia(sectionContent.media))} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} slides={slides} text={text} />;
}